import { render, staticRenderFns } from "./AppJson.vue?vue&type=template&id=72a1d8c0&"
import script from "./AppJson.vue?vue&type=script&lang=js&"
export * from "./AppJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports